/** Podpis XAdES w dokumencie wniosku o zaangażowanie (jeden na podpisany element). */
export interface IBudgetEngagementDocumentSignature {
  /** Id podpisanego elementu: „metrykaZaangazowania” albo „Ak-{przydział}”. */
  ElementId: string;
  SignerName?: string | null;
  IssuerName?: string | null;
  /** ISO (UTC). */
  SigningTime?: string | null;
}

/**
 * Dokument wniosku o zaangażowanie środków budżetowych (BE: BudgetEngagementDocuments,
 * schemat WnioZaangBudz/2018/02/21 — port z Magistratu). XML idzie do wtyczki do podpisu,
 * HTML (arkusz XSL renderowany przez BE) — do podglądu.
 */
export interface IBudgetEngagementDocument {
  Id: string;
  EngagementId: string;
  InstanceId?: string | null;
  /** Rośnie przy każdej zmianie treści (etap, podpis) — wysyłana przy dołączaniu podpisu. */
  Version: number;
  LastModified: string;
  Xml: string;
  Html: string;
  FileName: string;
  Signatures: IBudgetEngagementDocumentSignature[];
  /** Elementy, które bieżący użytkownik może jeszcze podpisać elektronicznie. */
  MySignableElementIds: string[];
}

/** Id elementu metryki zaangażowania (podpis wnioskodawcy). */
export const ENGAGEMENT_METRIC_ELEMENT_ID = "metrykaZaangazowania";

/** Czytelna nazwa podpisywanego elementu dokumentu. */
export const engagementElementLabel = (elementId: string) =>
  elementId === ENGAGEMENT_METRIC_ELEMENT_ID
    ? "metryka zaangażowania (wnioskodawca)"
    : "etap akceptacji";
